
//import "./services/DSigner/dCommon.min.js";
//import "./services/DSigner/dSigXadesBp.min.js";
import FormEngine from "./services/FormEngine";
import EventSystem from "./services/Events/EventSystem";

if (!window.engineConfig) {
  console.error("Missing engine config!");
}

if(window.engineConfig.suppressConsoleLog){
  console.log = function() {};
}

EventSystem.initialize();
if (window.engineSetup) {
  window.engineSetup(EventSystem, window.engineConfig, window.defaultXml);
}
const formEngine = new FormEngine(window.engineConfig, window.defaultXml);
window.FormEngine = formEngine;
await formEngine.loadStructure(window.structure);
if(window.FormEngine.engineConfig.startupLanguageCode !== formEngine.translation.defaultLanguage){
  formEngine.translation.defaultLanguage = window.FormEngine.engineConfig.startupLanguageCode;
  formEngine.translation.currentLanguage = window.FormEngine.engineConfig.startupLanguageCode;
}
formEngine.translation.init();


export default formEngine;
